import defaultBannerImage from 'static/images/default-page-banner.jpg';
import Error from './error/error-page';
import { getEventPageTitle } from 'app/utilities/seo';
import Helmet from 'react-helmet';
import { isAppProd } from 'config/env';
import NotFound from './error/not-found-page';
import PropTypes from 'prop-types';
import React from 'react';
import { RESPONSE } from 'config/api';
import StructuredData from 'app/components/partials/structured-data';
import Template from 'app/components/templates/index';
import templateType from 'app/utilities/template-type';
import { buildCanonicalUrl, buildPageGraph } from 'app/utilities/structured-data';

const APP_NAME = 'Auckland Stadiums';

const ContentPage = ({ page }) => {
    // Render not error/not found page
    if (!page || page.error && page.error.status === RESPONSE.INTERNAL_SERVER_ERROR) return <Error />;
    if (page.error && page.error.status === RESPONSE.NOT_FOUND || !page.attributes) return <NotFound />;

    const {
        is_published: isPublished,
        name,
        main_images: mainImages,
        seo_description: seoDescription,
        seo_keywords: seoKeywords,
        slug,
        thumbnail,
        start_date: startDate,
        end_date: endDate
    } = page.attributes;

    const { type } = page;
    const canonicalUrl = buildCanonicalUrl(page);
    const structuredData = buildPageGraph(page, canonicalUrl);

    let image = mainImages && mainImages[0] || thumbnail;

    if (!image) {
        image = `https://www.aucklandstadiums.co.nz${defaultBannerImage}`;
    }

    const isNoIndex = !isAppProd || !isPublished;
    const titleToUse = type === 'events' ? getEventPageTitle(name, startDate, endDate) : name;
    const title = titleToUse && titleToUse.toLowerCase() === 'home' ? APP_NAME : `${titleToUse} | ${APP_NAME}`;

    return (
        <main className="page" role="main">
            <Helmet>
                {isNoIndex && <meta name="robots" content="noindex, nofollow" />}

                <title>{title}</title>
                <meta name="description" content={seoDescription} />
                <meta name="keywords" content={seoKeywords} />
                <link rel="canonical" href={canonicalUrl} />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={title} />
                <meta name="twitter:description" content={seoDescription} />
                <meta name="twitter:image" content={image} />

                {/* Open Graph */}
                <meta property="og:locale" content="en_NZ" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={seoDescription} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:image" content={image} />
            </Helmet>
            <Template
                type={templateType(slug, type)}
                data={page.attributes}
            />
            {structuredData && <StructuredData data={structuredData} />}
        </main>
    );
};

ContentPage.propTypes = {
    page: PropTypes.object.isRequired
};

export default ContentPage;
